import { StrategyExpanded } from "@bridgesplit/abf-react";
import { STRATEGY_LOANS_SLUG } from "app/constants";

export function getStrategyLoansPath(strategy: StrategyExpanded | undefined) {
    if (strategy) {
        return `${STRATEGY_LOANS_SLUG}/${strategy.address}`;
    }
    return "#";
}
